var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 915,
    height: 340,
    viewBox: "0 0 915 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.5 20L92 179H118L192 20H228L153.5 179H179.5L253.5 20H327V282.5H286.5V217H205.5L175 282.5H130L162 217H135.5L104.5 282.5H70L100.5 217H74.5L44 282.5H20L142.5 20H166.5ZM276.682 63.5L222.715 179H287.5V63.5H276.682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 20H404V284H363V20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.705 181.039C819.705 156.673 807.351 141.917 786.074 141.917C761.365 141.917 751.07 161.134 751.07 187.216V283.992H710.335V109.315H751.07V134.71H753.129C763.081 118.237 778.524 106.569 802.547 106.569C837.207 106.569 861.865 130.249 861.865 171.773V283.992H819.705V181.039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.143 276.785C536.961 276.785 507.448 239.036 507.448 190.304C507.448 140.544 536.961 106.569 578.143 106.569C601.135 106.569 619.667 117.894 628.933 135.053H630.649V108.628H671.384V271.637C671.384 313.848 645.062 343.018 593.242 343.018C544.511 343.018 519.803 316.593 514.998 291.542H559.611C565.445 302.523 575.054 309.387 592.899 309.387C620.01 309.387 630.649 292.228 630.649 271.637V247.615H628.933C619.324 263.401 602.508 276.785 578.143 276.785ZM552.061 191.334C552.061 218.102 565.102 242.467 591.183 242.467C617.608 242.467 630.306 218.102 630.306 192.364C630.306 166.625 618.294 140.544 591.527 140.544C566.131 140.544 552.061 163.537 552.061 191.334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.274 283.724L439.931 109.047H481.009V283.724H440.274ZM438.215 81.9358V43.5H482.725V81.9358H438.215Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_1581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 915,
    height: 340,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLogo);
export default __webpack_public_path__ + "static/media/align_logo.5c820845889b761f69e3a7f6f8f6ae55.svg";
export { ForwardRef as ReactComponent };